import { buildCustomTheme } from './customTheme';
import { aurinkoTheme } from './aurinko';
import { dinoTheme } from './dino';
import { oceanTheme } from './ocean';
import { pastelTheme } from './pastel';
import { princessTheme } from './princess';
import { skyTheme } from './sky';
import { spaceTheme } from './space';
import { talviTheme } from './talvi';
import type { CustomTheme, Theme } from './types';

// Re-export the legacy sentinel so existing callers keep working — the
// canonical definition lives in `./customTheme` to avoid an import
// cycle (registry → customTheme → registry).
export { CUSTOM_THEME_KEY } from './customTheme';

// Theme registry per plan/01 D6. Adding a theme: create a folder,
// import + push it here. Order is the order shown in the picker.
export const THEMES: readonly Theme[] = [
  skyTheme,
  aurinkoTheme,
  spaceTheme,
  oceanTheme,
  talviTheme,
  princessTheme,
  dinoTheme,
  pastelTheme,
];

export const DEFAULT_THEME = skyTheme;

// Resolve a theme key against the preset registry first, then the
// family library. Falls back to `DEFAULT_THEME` on a miss so a stale
// reference (deleted custom theme, mistyped key) can't crash a kid
// mid-tap. The library param is optional so tests + boot code without
// store access keep the old one-arg behaviour.
export function getTheme(
  key: string | null | undefined,
  customThemes?: readonly CustomTheme[],
): Theme {
  if (!key) return DEFAULT_THEME;
  const preset = THEMES.find((t) => t.key === key);
  if (preset) return preset;
  if (customThemes) {
    const custom = customThemes.find((c) => c.id === key);
    if (custom) {
      try {
        return buildCustomTheme(custom);
      } catch {
        return DEFAULT_THEME;
      }
    }
  }
  return DEFAULT_THEME;
}
